import { render, staticRenderFns } from "./digital-currency-alternative-resource-item-1-find-digital-currency-alternatives.vue?vue&type=template&id=5bf5d28c&scoped=true&"
import script from "./digital-currency-alternative-resource-item-1-find-digital-currency-alternatives.vue?vue&type=script&lang=ts&"
export * from "./digital-currency-alternative-resource-item-1-find-digital-currency-alternatives.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf5d28c",
  null
  
)

export default component.exports